/**
 * Vidu Q3 Pro：文生 / 图生视频
 * 图生：input.image（HTTPS URL）、prompt、length、resolution、seed?、generateAudio?
 * 文生：prompt、length、aspectRatio、resolution、seed?、generateAudio?（无 image）
 */
import { isUrl, clampSeed } from './utils'

function normalizeResolution(v) {
  if (!v) return '720p'
  var s = String(v).trim()
  if (/^2k$/i.test(s)) return '2K'
  var lower = s.toLowerCase()
  var allowed = ['360p', '540p', '720p', '1080p']
  if (allowed.indexOf(lower) !== -1) return lower
  return '720p'
}

function normalizeLength(n) {
  var num = parseInt(n, 10)
  if (isNaN(num)) return 5
  if (num < 1) return 1
  if (num > 16) return 16
  return num
}

export function buildBody(params) {
  var prompt = (params.prompt || '').trim().slice(0, 2000)
  var hasImage = isUrl(params.referenceImage)
  var input = {
    prompt: prompt,
    length: normalizeLength(params.videoDuration != null ? params.videoDuration : params.length),
    resolution: normalizeResolution(params.videoRes || params.resolution),
    generateAudio: params.generateAudio !== false
  }

  var seed = clampSeed(params.seed)
  if (seed != null) input.seed = seed

  if (hasImage) {
    input.image = String(params.referenceImage).trim()
  } else {
    var ar = params.aspectRatio || '16:9'
    var allowedAr = { '16:9': 1, '9:16': 1, '1:1': 1, '4:3': 1, '3:4': 1 }
    input.aspectRatio = allowedAr[ar] ? ar : '16:9'
  }

  var body = { input: input }
  if (params.webhookUrl && isUrl(params.webhookUrl)) body.webhookUrl = String(params.webhookUrl).trim()
  return body
}
